import { useTokensStore } from '../../../../../store/tokensStore';
import { BalanceElement } from './BalanceElement';
import {formatDollarAmount} from '../../../../../utils/formatDollarAmount';
import { useContextProvider } from '../../../../../context';

export const CurrensyList = () => {
  const { userTokens } = useTokensStore();
  const { nativeCurrency } = useContextProvider();

  return (
    <>
        {!!userTokens?.length && <ul className="flex flex-col text-balse gap-2 mt-6 [&>li:not(:last-child)]:border-white-main-bg dark:[&>li:not(:last-child)]:border-blue-darkMode-20  [&>li]:border-transparent">
          {nativeCurrency && (
            <BalanceElement
              icon={nativeCurrency.iconUrl}
              symbol={nativeCurrency.symbol}
              valueFirst={
                formatDollarAmount(nativeCurrency.valueInUsdt, 2, 2, '$') || '0'
              }
              valueSecond={formatDollarAmount(
                parseFloat(nativeCurrency.formatted),
                2,
                2,
                ' '
              )}
            />
          )}
          {userTokens.map((token, i) => (
            <BalanceElement
              key={i}
              icon={token.iconUrl}
              symbol={token.symbol}
              valueFirst={
                formatDollarAmount(token.valueInUsdt, 2, 2, '$') || '0'
              }
              valueSecond={formatDollarAmount(token.value, 2, 2, ' ')}
            />
          ))}
        </ul>}
    </>
  );
};
